/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["section[_ngcontent-%COMP%]{padding:1rem}section[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-weight:700;margin-bottom:1rem}section[_ngcontent-%COMP%]   .toggle-password[_ngcontent-%COMP%]{margin:5% 0}[_nghost-%COMP%]     app-input .remax-input.form-group{margin-bottom:5%}@media (max-width:1199px){.my-account-wrapper[_ngcontent-%COMP%]{background-color:#fff;margin:2%}}"];
export { styles as styles };
